import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-avg-scan-time',
  templateUrl: './avg-scan-time.component.html',
  styleUrls: ['./avg-scan-time.component.css']
})
export class AvgScanTimeComponent implements OnInit {
  @Input() entityDetails: any;
  @Input() widgetData: any;
  @Input() entityId: string;
  constructor() { }

  ngOnInit(): void {
  }

}
